import { RequireCapability } from "@/components/RequireCapability";

import { ConsentsApp } from "./components/ConsentsApp";
import { PartnersApp } from "./components/PartnersApp";
// Registers the slice's partners.*/consents.* translations (side-effect import).
import "./i18n";

/**
 * Partner-group management area (route: /partner-group). Group list + detail
 * (members, license pool, invitations), admin-only regional-partner (super-user)
 * management, local-partner invite/promote, and invitation acceptance
 * (`?accept=<token>`). Built on the partners API merged in Wave 1.
 *
 * Only an authenticated session is required at the route level: invitation
 * acceptance (`?accept=<token>`) must be reachable by a brand-new invitee who
 * does not yet hold the `partnerGroups` capability. PartnersApp applies the
 * stricter capability gate around the management surface, and the inner
 * super-user tab is additionally gated to platform admins.
 */
export function PartnersPage() {
  return (
    <RequireCapability required={["authenticated"]}>
      <PartnersApp />
    </RequireCapability>
  );
}

/**
 * Consent area (route: /consents). Members grant/revoke what their partner
 * group may see (autosaved); partners/admins also get a member-consent lookup.
 * Only an authenticated session is required — the inner partner view refines
 * the guard.
 */
export function ConsentsPage() {
  return (
    <RequireCapability required={["authenticated"]}>
      <ConsentsApp />
    </RequireCapability>
  );
}
